export default {
  "content": "<path d=\"M0 10.6L4.56 6 0 1.4 1.4 0l5.975 6L1.4 12 0 10.6z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "8",
    "height": "12",
    "viewBox": "0 0 8 12"
  }
};